import React, { Component } from 'react';
import logo from './logo.jpg';
import './App.css';
import Shop from './Shop.js';
import { Collapse,
         Navbar,
         NavbarToggler,
         Nav,
         NavItem,
         NavLink } from 'reactstrap';

import { BrowserRouter, Route} from 'react-router-dom';

import {
  faYoutube,
  faFacebook,
  faTwitter,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Countdown from './Countdown.js';

export default class Home extends Component{
  constructor(props){
    super(props);
    this.state={};
  }


  render(){
    const currentDate = new Date();
    const year = (currentDate.getMonth() === 11 && currentDate.getDate() > 23) ? currentDate.getFullYear() + 1 : currentDate.getFullYear();
   
    return(
      <div>
        <section>
          
          <header className="App-header">
            

            <p className="logoName">
              BİKİVİ
            </p>
            <div className="blurBox">
              <p className="inBuild">
                Geri Sayım Başladı...
                
              </p> 

              <Countdown date={`${year}-11-24T00:00:00`} />

              <p className="info1">
                
                <NavLink className="info1" href="/shop">Güncel fiyatlarımız için tıklayın.</NavLink>
                <br/>
                
                Siparişleriniz için
                <br/>
                WhatsApp: +90 533 460 45 38
                <br/>


                <br/>
                Bizi Sosyal Medya Üzerinden Takip Edebilirsiniz...
                <br/>
                <FontAwesomeIcon icon={faYoutube} size="2x" />
                &nbsp;
                <FontAwesomeIcon icon={faTwitter} size="2x" />
                &nbsp;
                <FontAwesomeIcon icon={faFacebook} size="2x" />
                &nbsp;
                <a href="https://www.instagram.com/bikivi_/">
                  <FontAwesomeIcon icon={faInstagram} size="2x" />
                </a>
                <br/>
              </p>
            </div>

            
            
          </header>
        </section>
      </div>
    );
  }
}
